import { createSelector } from "reselect";

const resourceTypes = {};

/**
 * Returns all resourceTypes.
 * @param {Object} state
 * @returns {Object[]} resourceTypes
 */
resourceTypes.get = state => state.resourceTypes.items;

/**
 * Returns uri of current resourceType.
 * @param {Object} state
 * @returns {string} uri
 */
resourceTypes.getCurrentUri = state => state.resourceTypes.current;

/**
 * Returns resourceTypes not attached to self-referential RBAC product.
 * @param {Object} state
 * @returns {Object[]} resourceTypes
 */
resourceTypes.getFiltered = createSelector(
  [resourceTypes.get],
  types => types.filter(type => type.product.$ref !== "/api/rbac/v1/product/1")
);

/**
 * Returns resourceTypes of a product.
 * @param {Object} state
 * @param {Object} product
 * @returns {Object[]} resourceTypes
 */
resourceTypes.getByProduct = (state, product) =>
  state.resourceTypes.items.filter(type => type.product.$ref === product.$uri);

/**
 * Return current resourceType object
 * @param {object} state
 * @returns {Object} product
 */
resourceTypes.getCurrent = createSelector(
  [resourceTypes.getCurrentUri, resourceTypes.get],
  (currentResourceTypeUri, resourceTypes) =>
    resourceTypes.find(type => type.$uri === currentResourceTypeUri)
);

export default resourceTypes;
